export * from './lib/ui-tooltip.module';
